import React from "react";
import "./button.css"

export const Button = ({ enabled = true, onClick = () => { }, text = "", children }) => {
    return <button className={`button-agendamento ${enabled ? "enabled" : ""}`} onClick={() => enabled ? onClick() : () => { }}>
        {text}
    </button>
}